import '../scss/app.scss'; // Importing SCSS file


console.log('testing');
 